import controller from './counter.controller';

const template = require('./counter.html');

export default {
    bindings: {
        device: '<',
        onPublishEvent: '&'
    },
    controller,
    template
};
